module.exports = __webpack_public_path__ + "static/media/Date.25ff74ba.svg";